import { ApolloProvider } from '@apollo/client'
import React from 'react'

import client, { createClient } from './client'

// In most standard ( non railsy ) react apps there is a root level App component
// in to which we can place the apollo wrapper. But we don't have that. As such we need to
// wrapp each page component in the apollo provider using this HOC

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function withApollo<P>(
  WrappedComponent: React.ComponentType<P>,
  graphqlController?: string
) {
  const ComponentWithApollo = (props: P) => {
    const apolloClient = graphqlController
      ? createClient(graphqlController)
      : client

    return (
      <ApolloProvider client={apolloClient}>
        {/* @ts-expect-error - erroring when upgrading to TS 5.8.2 */}
        <WrappedComponent {...props} />
      </ApolloProvider>
    )
  }
  return ComponentWithApollo
}

export default withApollo
